import React, { useRef } from 'react';
import { toast } from "react-toastify";

import { uploadEligibilityExcelSvc } from './eligibilityReportSvc';


const UploadEligibility = (props) => {
    const { setEligibilityExcelFile, setLoader, setOpacity, updateKey } = props;
    const fileInputRef = useRef(null);


    const handleFileChange = (event) => {
        // console.log("handleFileChange called");
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            uploadFile(file);
        } else {
            setLoader("none");
            setOpacity(1);
        }
        // Reset input so the same file can be selected again
        event.target.value = "";
    };

    const uploadFile = (file) => {
        // console.log("uploadFile called with file:", file);
        if (!file) {
            toast.error("No file selected. Please select a valid Excel file.");
            return;
        }
        setEligibilityExcelFile(file);

        setLoader("block");
        setOpacity(0.5);

        uploadEligibilityExcelSvc(file, (response) => {
            if (response.status === "Success") {
                toast.success(response.message);
                updateKey();
            } else {
                handleServiceError(response.message);
            }
            setLoader("none");
            setOpacity(1);
        });
    };


    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };


    return (
        <div>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleFileChange}
            />
            <span
                title="Upload Eligibility"
                className="addIcon glyphicon glyphicon-upload"
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                style={{ paddingLeft: '10px', cursor: 'pointer' }}>
            </span>
        </div>
    );
}

export default UploadEligibility;
